import HttpClient from 'services/HttpClient'
import {
  LoginPayload,
  ResetPasswordPayload,
  SetPasswordPayload,
  SetPolicyAcceptance
} from 'types/auth'

export class AuthRepository {
  api: typeof HttpClient

  constructor(api: typeof HttpClient) {
    this.api = api
  }

  // User
  login(payload: LoginPayload) {
    return this.api.post('/auth/signin', payload)
  }

  resetPassword(payload: ResetPasswordPayload) {
    return this.api.post('/auth/password-reset-init', payload)
  }

  resendSetPasswordInvitation(payload: ResetPasswordPayload) {
    return this.api.post('/auth/resend-set-password-invitation', payload)
  }

  setPassword(payload: SetPasswordPayload) {
    return this.api.post('/auth/password-reset-finish', payload)
  }

  getProfile() {
    return this.api.get('/auth/profile')
  }

  refreshAuthToken() {
    return this.api.post('/auth/refresh-token')
  }

  setPolicyAcceptance(payload: SetPolicyAcceptance) {
    return this.api.patch(`/users/${payload.userId}`, {
      privacyPolicyFlag: payload.privacyPolicyFlag,
      newsletterFlag: payload.newsletterFlag
    })
  }
}

 
export default new AuthRepository(HttpClient)
